module.exports = __webpack_public_path__ + "img/ew-icon_reset.96e7ad2b.svg";